import { formatPrice } from "../services/formatterService";
import { showAlertAtom, alertMessageAtom, orderAtom, isLoadingAtom, showProformaAtom } from "../atoms/atoms";
import { useAtom, useSetAtom } from "jotai";
import { IsValidEmail, OrderValidationMessage } from "../services/validationService";
import productApi from "../api/productApi";

const ProFormaButton = ({ product }) => {

    const setShowAlert = useSetAtom(showAlertAtom);
    const setAlertMessage = useSetAtom(alertMessageAtom);
    const [order,setOrder] = useAtom(orderAtom);
    const setIsLoading = useSetAtom(isLoadingAtom);
    const setProforma = useSetAtom(showProformaAtom);


    const handleClick = () => {
        if (!order.needInvoice) {
            setAlertMessage('Proszę zaznaczyć opcję "Potrzebuję fakturę VAT" oraz podać dane do faktury.');
            setShowAlert(true);
            return false;
        }
        const message = OrderValidationMessage(order);
        if (message.length === 0) {
            setIsLoading(true);
            createOrder();
        } else {
            setAlertMessage(message);
            setShowAlert(true);
            return false;
        }
    }



    const createOrder = () =>{
    
        const makeOrder = async () => {
            try {
                let response = await productApi.RequestProForma(order);
                if (response.data && response.data.success) {
                    setProforma(true);
                    
                } else {
                    setAlertMessage('Nie udało nam się zapisać danych. Spróbuj ponownie wkrótce.');
                    setShowAlert(true);
                }
                
            } catch (err) {
                setAlertMessage("Nie udało nam się zapisać danych. Spróbuj ponownie wkrótce.");
                setShowAlert(true);
            }
            finally {
                setIsLoading(false);
            }
        }

        makeOrder();
    }

    return (
        <>
            <button className="btn btn-outline-primary py-3 mt-5 w-100" onClick={handleClick}>
                <strong>
                    Proszę o wystawienie faktury pro-forma na powyższe dane
                </strong>
            </button>
        </>

    )
}

export default ProFormaButton;